import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../styles/ChangePasswordPopup.scss";

const ChangePasswordPopup = ({ isOpen, onClose, onChangePassword }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const validateForm = () => {
    const newErrors = {};

    if (!oldPassword) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "New password must be at least 6 characters";
    } else if (newPassword === oldPassword) {
      newErrors.newPassword = "New password must be different from old password";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onChangePassword({
      oldPassword,
      newPassword,
      confirmPassword,
    });

    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleClose = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleInputChange = (field, value) => {
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }

    switch (field) {
      case "oldPassword":
        setOldPassword(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  return createPortal(
    <div className="change-password-overlay" role="dialog" aria-modal="true">
      <div className="change-password-modal">
        <div className="change-password-header">
          <h3 className="change-password-title">Change Password</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="change-password-body">
            <div className="change-password-form-group">
              <label className="change-password-label">Old Password</label>
              <input
                type="password"
                value={oldPassword}
                onChange={(e) =>
                  handleInputChange("oldPassword", e.target.value)
                }
                className={`change-password-input ${
                  errors.oldPassword ? "error" : ""
                }`}
              />
              <div className="change-password-error-container">
                {errors.oldPassword && (
                  <p className="change-password-field-error">
                    {errors.oldPassword}
                  </p>
                )}
              </div>
            </div>
            <div className="change-password-form-group">
              <label className="change-password-label">New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) =>
                  handleInputChange("newPassword", e.target.value)
                }
                className={`change-password-input ${
                  errors.newPassword ? "error" : ""
                }`}
              />
              <p className="popup-help-text" style={{ fontSize: "11px", color: "var(--text-secondary, #6b7280)", marginTop: "4px", marginBottom: "0" }}>
                Must be at least 6 characters.
              </p>
              <div className="change-password-error-container">
                {errors.newPassword && (
                  <p className="change-password-field-error">
                    {errors.newPassword}
                  </p>
                )}
              </div>
            </div>
            <div className="change-password-form-group">
              <label className="change-password-label">
                Confirm New Password
              </label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                className={`change-password-input ${
                  errors.confirmPassword ? "error" : ""
                }`}
              />
              <div className="change-password-error-container">
                {errors.confirmPassword && (
                  <p className="change-password-field-error">
                    {errors.confirmPassword}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="change-password-footer">
            <button
              type="button"
              className="change-password-btn change-password-btn-secondary"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="change-password-btn change-password-btn-primary"
            >
              Update Password
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default ChangePasswordPopup;
